import React from 'react';
import {Modal} from "antd";
import {injectIntl} from "react-intl";
import connect from "react-redux/es/connect/connect";
import {withAuthorization} from "../../../services/Authorization";
import RentalCar from "./carmodification/RentalCar";

class CarCreationModal extends React.Component {

  constructor(props) {
    super(props);
    this.state = {};
  }

  componentWillReceiveProps = (nextProps) => {
    if (nextProps.saveRentalVehicle && nextProps.saveRentalVehicle.error) {
      const errors = nextProps.saveRentalVehicle.error.content || {};
      this.setState({errors})
    }
    if (nextProps.updateRentalVehicle && nextProps.updateRentalVehicle.error) {
      const errors = nextProps.updateRentalVehicle.error.content || {};
      this.setState({errors})
    }
  };

  componentDidMount = () => {
    const {selectedCar} = this.props;

    if (selectedCar) {
      const {picture, lastReport} = selectedCar;
      const vehicle = Object.assign({}, selectedCar);

      vehicle.category = selectedCar.category.toUpperCase();
      if (picture) {
        vehicle.picture = [{uid: picture.key, url: picture.url}];
      }
      if (lastReport) {
        vehicle.mileage = lastReport.mileage;
        vehicle.fuel = lastReport.fuel;
        vehicle.advisorComment = lastReport.advisorComment;
        vehicle.attachments = lastReport.attachments.map(a => ({uid: a.key, url: a.url}))
      }
      this.setState({vehicle});
    }
  };

  onSave = (data) => {
    const {vehicle, outdatedFiles, fileList} = data;

    const form = new FormData();
    fileList['attachments'] && fileList['attachments'].forEach((file) => {
      form.append('attachments', file)
    });
    fileList['picture'] && fileList['picture'].forEach((file) => {
      form.append('picture', file)
    });
    if (outdatedFiles) {
      form.append("outdatedFiles", outdatedFiles);
    }

    vehicle.vehicleId && form.append("vehicleId", vehicle.vehicleId);
    vehicle.brand && form.append("brand", vehicle.brand);
    vehicle.model && form.append("model", vehicle.model);
    vehicle.modelCode && form.append("modelCode", vehicle.modelCode);
    vehicle.color && form.append("color", vehicle.color);
    vehicle.category && form.append("category", vehicle.category);
    vehicle.fuelType && form.append("fuelType", vehicle.fuelType);
    vehicle.gearbox && form.append("gearbox", vehicle.gearbox);
    vehicle.co2&& form.append("co2", vehicle.co2);
    vehicle.licensePlate && form.append("licensePlate", vehicle.licensePlate);
    vehicle.vin && form.append("vin", vehicle.vin);
    vehicle.remark && form.append("remark", vehicle.remark);
    vehicle.registrationDate && form.append("registrationDate", vehicle.registrationDate);
    vehicle.deactivationDate && form.append("deactivationDate", vehicle.deactivationDate);
    vehicle.advisorComment && form.append("comment", vehicle.advisorComment);
    vehicle.additionalKmRate && form.append("additionalKmRate", vehicle.additionalKmRate);
    vehicle.deductible && form.append("deductible", vehicle.deductible);
    vehicle.mileage && form.append("mileage", vehicle.mileage || '');
    vehicle.fuel && form.append("fuel", vehicle.fuel);

    !vehicle.vehicleId ? this.props.dispatchSaveRental(form) : this.props.dispatchUpdateRental(vehicle.vehicleId, form);
  };

  render() {
    const {intl:{formatMessage}, visible} = this.props;
    const {vehicle, errors = {}} = this.state;

    return (
      <Modal title={formatMessage({id: 'section.car-creation.modal.title'})} visible={visible} onCancel={this.props.onModalClose} width="80rem" style={{top: "5rem"}} footer={null}>
          <div className="box__body--no-padding">
            <RentalCar onSave={this.onSave} vehicle={vehicle} errors={errors} />
          </div>
      </Modal>
    )
  }
}

const mapStateToProps = state => ({
  saveRentalVehicle: state.saveRentalVehicle,
  updateRentalVehicle: state.updateRentalVehicle,
});

const mapDispatchToProps = dispatch => ({
  dispatchSaveRental: (body) => dispatch({type: 'SAVE_RENTAL_VEHICLE.REQUEST', body}),
  dispatchUpdateRental: (id, body) => dispatch({type: 'UPDATE_RENTAL_VEHICLE.REQUEST', id, body}),
});

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(withAuthorization(injectIntl(CarCreationModal), ['DUI_ADMIN', 'DUI_SERVICE_ADVISOR']));
